import script from "./BaseModal.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseModal.vue?vue&type=script&setup=true&lang=js"

import "./BaseModal.vue?vue&type=style&index=0&id=cecec5c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cecec5c4"]])

export default __exports__